import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const FolderSharedMultiple = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <SvgIcon {...props} ref={ref} viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0001 4.99992H16.6667C17.5834 4.99992 18.3334 5.74992 18.3334 6.66659V14.9999C18.3334 15.9166 17.5834 16.6666 16.6667 16.6666H3.33341C2.41675 16.6666 1.66675 15.9166 1.66675 14.9999L1.67508 4.99992C1.67508 4.08325 2.41675 3.33325 3.33341 3.33325H8.33341L10.0001 4.99992ZM13.5667 8.92849C13.5667 9.71897 12.9334 10.3571 12.1429 10.3571C11.3525 10.3571 10.7144 9.71897 10.7144 8.92849C10.7144 8.13801 11.3525 7.49992 12.1429 7.49992C12.9334 7.49992 13.5667 8.13801 13.5667 8.92849ZM9.75722 8.92849C9.75722 9.71897 9.12389 10.3571 8.33341 10.3571C7.54294 10.3571 6.90484 9.71897 6.90484 8.92849C6.90484 8.13801 7.54294 7.49992 8.33341 7.49992C9.12389 7.49992 9.75722 8.13801 9.75722 8.92849ZM5.00008 12.9761C5.00008 11.8666 7.22389 11.3094 8.33341 11.3094C9.44294 11.3094 11.6667 11.8666 11.6667 12.9761V14.1666H5.00008V12.9761ZM11.681 11.3333C11.8477 11.319 12.0048 11.3094 12.1429 11.3094C13.2525 11.3094 15.4763 11.8666 15.4763 12.9761V14.1666H12.6191V12.9761C12.6191 12.2713 12.2334 11.7333 11.681 11.3333Z"
      />
    </SvgIcon>
  )
);

FolderSharedMultiple.displayName = 'FolderSharedMultiple';

export default FolderSharedMultiple;
